<script>
    import configuration from '../configuration.json';
    import app from '../data/app.svelte.js';
    import persistent from '../data/persistent.svelte';
    import { currentSession, currentSessionId } from '../data/session.svelte.js';
    
    import { onMount } from 'svelte';
    import { _ } from 'svelte-i18n';
    import { next, previous, goto, replace } from '../helpers/navigation.svelte.js';

    import Section from '../components/Section.svelte';
    import Status from '../components/Status.svelte';
    import Navigation from '../components/Navigation.svelte';
    import Button from '../components/Button.svelte';
    
    import Icon from '../components/Icon.svelte';
    import arrowRightIcon from '../assets/icons/arrow-right.svg?raw';

    let { route } = $props();

    const error = route.result.path.params.error || 'unknown_error';


    /* Determine URL for making a new appointment */

    let url = $derived(window.location.origin + '/' + currentSession.client + '/' + currentSession.salon);


</script>

{#if error === 'incomplete'}
    <Section title={$_('problem')}>
        <Status icon="failed">
            {$_('error_occurred')}
        </Status>

        <p>
            {$_('missing_required_data')}
        </p>
    </Section>
{:else if error === 'failed'}
    <Section title={$_('problem')}>
        <Status icon="failed">
            {$_('error_occurred')}
        </Status>

        {#if currentSession.type === 'waitlist'}
            <p>
                Er is een fout opgetreden tijdens het aanmelden voor de wachtlijst. Probeer het opnieuw of neem contact op met de salon.
            </p>
        {:else}
            <p>
                {$_('error_appointment_failed')}
            </p>
        {/if}
    </Section>
{:else if error === 'session-not-found'}
    <Section title={$_('problem')}>
        <Status icon="failed">
            {$_('session_not_found')}
        </Status>

        <p>
            {$_('session_not_found_description')}
        </p>
    </Section>
{:else if error === 'verify-time-no-longer-available'}
    <Section title={$_('problem')}>
        <Status icon="failed">
            {$_('time_no_longer_available')}
        </Status>

        <p>
            {$_('time_no_longer_available_description')}
        </p>
    </Section>
{:else if error === 'verify-failed'}
    <Section title={$_('problem')}>
        <Status icon="failed">
            {$_('verification_failed')}
        </Status>

        <p>
            {$_('verification_failed_description')}
        </p>
    </Section>
{:else if error === 'cancel-failed'}
    <Section title={$_('problem')}>
        <Status icon="failed">
            {$_('cancel_failed')}
        </Status>

        <p>
            {$_('cancel_failed_description')}
        </p>
    </Section>


{:else if error === 'customer-check-failed'}
    <Section title={$_('problem')}>
        <Status icon="failed">
            {$_('customer_check_failed')}
        </Status>

        <p>
            {$_('customer_check_failed_description')}
        </p>
    </Section>


{:else if error === 'customer-blocked'}
    <Section title={$_('problem')}>
        <Status icon="failed">
            {$_('customer_blocked')}
        </Status>

        <p>
            {$_('customer_blocked_description')}
        </p>
    </Section>


{:else if error === 'customer-rejected'}
    <Section title={$_('sorry')}>
        <Status icon="forbidden">
            {$_('customer_rejected')}
        </Status>

        <p>
            {$_('customer_rejected_description')}
        </p>

        <Navigation>
            <Button href={url}>
                {$_('try_again')}
                <Icon data={arrowRightIcon} />
            </Button>
        </Navigation>
    </Section>


{:else if error === 'salon-configuration-error'}
    <Section title={$_('sorry')}>
        <Status icon="failed">
            {$_('salon_configuration_error')}
        </Status>

        <p>
            {$_('salon_configuration_error_description')}
        </p>
    </Section>


{:else}
    <Section title={$_('problem')}>
        <Status icon="failed">
            {$_('unknown_error')}
        </Status>

        <p>
            {$_('unknown_error_description')}
        </p>
    </Section>
{/if}
